
export enum LegalTermsTypeCd {
	CREDIT_CARD_REGISTRATION = 'Credit Card Registration'}

